// Deutsche Namen zu den englischen Rollen- und Farbbezeichnern von chessground (für Beschriftungen).
import { t } from './i18n';

const ROLE: Record<string, string> = { king: 'König', queen: 'Dame', rook: 'Turm', bishop: 'Läufer', knight: 'Springer', pawn: 'Bauer' };
const COLOR: Record<string, string> = { white: 'Weiß', black: 'Schwarz' };

export const roleName = (role: string) => t(ROLE[role] ?? role);
export const colorName = (color: string) => t(COLOR[color] ?? color);
